import React from "react";

import {
  CircularProgress,
  Tooltip,
  IconButton,
  Typography,
  Divider,
  Button,
  Link,
  InputAdornment,
  TextField,
} from "@mui/material";

import { FileCopyOutlined } from "@mui/icons-material";

import "./style.css";
import { UPLOADED_MEDIA_URL } from "constants/serverUrl";
import { copyStringToClipboard } from "utils";

export default class FileDetailPanel extends React.Component {
  render() {
    const { selectedEntry, metadata } = this.props;
    return (
      <div style={{ padding: 10 }}>
        <Typography variant="body2" color="textSecondary">
          Copy-paste this link to insert this pic into your news
        </Typography>
        <div>
          <Link
            ref={(ref) => (this.linkDom = ref)}
            href={UPLOADED_MEDIA_URL + selectedEntry.path}
            target="blank"
            variant="body1"
            color="primary"
            style={{ lineHeight: 2.5, wordBreak: "break-all" }}
            underline="hover">
            {UPLOADED_MEDIA_URL + selectedEntry.path}
          </Link>
          <Tooltip
            title="Copy"
            children={
              <IconButton
                onClick={() =>
                  copyStringToClipboard(UPLOADED_MEDIA_URL + selectedEntry.path)
                }
                size="large">
                <FileCopyOutlined />
              </IconButton>
            }
          />
        </div>
        <div style={{ textAlign: "center" }}>
          <img
            className="image-thumbnail"
            alt="thumbnail"
            src={UPLOADED_MEDIA_URL + selectedEntry.path + "?width=600"}
          />
        </div>
        <div>
          <Button
            variant="contained"
            onClick={() =>
              typeof this.props.onEditClicked === "function" &&
              this.props.onEditClicked()
            }
          >
            Edit Photo
          </Button>
        </div>
        <Typography variant="subtitle1">
          <span className="fileinfo-label">File name </span>
          <span>{selectedEntry.name}</span>
        </Typography>
        {/* <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ flex: 1, marginRight: '1rem' }}>
            <TextField size="small" fullWidth margin="dense" variant="outlined"
              label="Filename"
              value={newFilename}
              onChange={e => this.setState({ newFilename: e.target.value })}
            />
          </div>
          <Button variant="contained" color="default" onClick={this.handleRename}>Rename</Button>
        </div> */}
        <Typography variant="subtitle1">
          <span className="fileinfo-label">File Size </span>
          <span>{selectedEntry.size_string}</span>
        </Typography>
        <Typography variant="subtitle1">
          <span className="fileinfo-label">Resolution </span>
          <span>
            {selectedEntry.dimension &&
              `${selectedEntry.dimension[0]} x ${selectedEntry.dimension[1]}`}
          </span>
        </Typography>
        <Typography variant="subtitle1">
          <span className="fileinfo-label">Created At </span>
          <span>{selectedEntry.created_at}</span>
        </Typography>
        <Divider />
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ flex: 1, marginRight: "1rem" }}>
            <TextField
              size="small"
              label="Credit"
              variant="outlined"
              fullWidth
              margin="dense"
              value={metadata.credit}
              inputProps={{
                startAdornment: (
                  <InputAdornment position="start">©</InputAdornment>
                ),
                endAdornment: metadata.loading && (
                  <InputAdornment position="end">
                    <CircularProgress size={30} />
                  </InputAdornment>
                ),
              }}
              onChange={(e) =>
                this.setState({
                  metadata: {
                    ...metadata,
                    credit: e.target.value,
                  },
                })
              }
            />
          </div>
          <div>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleChangeCredit}
            >
              Set Credit
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
